import { Stack, Tab, Tabs } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import PageLayout from '@shared/shell/Layout/PageLayout';
import { Collections } from '@features/collections';
import { ProductCatalogOnboardingOverlay } from '@features/tutorial';
import Products from './Products';

enum PageTab {
  PRODUCTS = 'products',
  COLLECTIONS = 'collections',
}

const ProductCatalog = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const tab =
    location.pathname === '/product-catalog/collections'
      ? PageTab.COLLECTIONS
      : PageTab.PRODUCTS;

  const handleTabChange = (_: React.SyntheticEvent, value: PageTab) => {
    if (value === PageTab.COLLECTIONS) {
      navigate('/product-catalog/collections');
    } else {
      navigate('/product-catalog/products');
    }
  };

  return (
    <PageLayout title="Products">
      <Stack borderBottom={1} borderColor="divider">
        <Tabs value={tab} onChange={handleTabChange}>
          <Tab sx={{ textTransform: 'none' }} label="Products" value={PageTab.PRODUCTS} />
          <Tab sx={{ textTransform: 'none' }} label="Collections" value={PageTab.COLLECTIONS} />
        </Tabs>
      </Stack>

      {tab === PageTab.PRODUCTS && <Products />}
      {tab === PageTab.COLLECTIONS && <Collections />}

      {tab === PageTab.PRODUCTS && <ProductCatalogOnboardingOverlay />}
    </PageLayout>
  );
};

export default ProductCatalog;
